(() => {
  if (window.pampasBannerFitV3) return;
  window.pampasBannerFitV3 = true;

  const applyFit = () => {
    const hero = document.querySelector('#MainContent pm-shoppable-hero');
    if (!hero) return;

    const section = hero.closest('[id^="shopify-section-"]');
    const media = hero.querySelector('.pm-content-over-media__media');

    section?.style.removeProperty('--pampas-hero-header-offset');

    if (media) {
      media.style.setProperty('transform', 'none', 'important');
      media.style.setProperty('scale', '1', 'important');
      media.style.removeProperty('transform-origin');
    }

    hero.querySelectorAll('.pm-shoppable-hero__slide .pm-image').forEach((image) => {
      const isRoshSlide = image.closest('.pm-shoppable-hero__slide--rosh');
      image.style.setProperty('object-fit', isRoshSlide ? 'fill' : 'contain', 'important');
      image.style.setProperty('object-position', 'center center', 'important');
      image.style.setProperty('transform', 'none', 'important');
      image.style.setProperty('scale', '1', 'important');
    });
  };

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(applyFit);
  };

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  if (document.readyState !== 'loading') schedule();
})();
